/* VITALIA PARIS — Panier tiroir (06/10/2026)
   - S'ouvre après chaque ajout au panier (vitalia.js appelle VPCart.afterAdd) et au clic sur l'icône panier.
   - Quantités et retrait sans rechargement : /cart/change.js renvoie directement le HTML de la section (API de rendu de sections).
   - Accessible : dialogue modal, focus piégé, Échap, retour du focus, défilement de la page bloqué, page inerte derrière.
   - Estimation de livraison calculée ici en jours ouvrés (week-ends et jours fériés français exclus) à partir du délai de chaque fiche. */
(function () {
  'use strict';
  var root = document.querySelector('[data-vpcd]');
  if (!root) return;
  var panel = root.querySelector('.vpcd__panel');
  var SECTION = 'vp-cart-drawer';
  var lastFocus = null, busy = false;

  /* ---------- Rendu ---------- */
  function swap(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-vpcd-body]');
    var cur = root.querySelector('[data-vpcd-body]');
    if (fresh && cur) cur.replaceWith(fresh);
    sync();
  }
  function sync() {
    var body = root.querySelector('[data-vpcd-body]');
    if (!body) return;
    var n = parseInt(body.getAttribute('data-count'), 10) || 0;
    document.querySelectorAll('.vp-header__icon[href$="/cart"]').forEach(function (a) {
      var b = a.querySelector('.vp-header__cart-count');
      if (n > 0) {
        if (!b) { b = document.createElement('span'); b.className = 'vp-header__cart-count'; a.appendChild(b); }
        if (b.textContent !== String(n)) { b.textContent = n; b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
      } else if (b) { b.remove(); }
      a.setAttribute('aria-label', n > 0 ? 'Panier, ' + n + (n > 1 ? ' articles' : ' article') : 'Panier');
    });
    eta();
  }
  function refresh() {
    return fetch(window.location.pathname + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j[SECTION]) swap(j[SECTION]); })
      .catch(function () { /* réseau ou page intermédiaire : le tiroir garde son contenu */ });
  }

  /* ---------- Estimation de livraison (jours ouvrés) ---------- */
  var HOLIDAYS = ['2026-11-01','2026-11-11','2026-12-25','2027-01-01','2027-03-29','2027-05-01','2027-05-06','2027-05-08','2027-05-17','2027-07-14','2027-08-15','2027-11-01','2027-11-11','2027-12-25','2028-01-01','2028-04-17','2028-05-01','2028-05-08','2028-05-25','2028-06-05','2028-07-14','2028-08-15'];
  function ymd(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function addBusiness(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6 && HOLIDAYS.indexOf(ymd(d)) < 0) n--; }
    return d;
  }
  function eta() {
    var out = root.querySelector('[data-vpcd-eta]');
    if (!out) return;
    var lo = 0, hi = 0;
    root.querySelectorAll('.vpcd__item[data-dw]').forEach(function (li) {
      var m = (li.getAttribute('data-dw') || '').match(/(\d+)\D+(\d+)/);
      if (m) { lo = Math.max(lo, +m[1]); hi = Math.max(hi, +m[2]); }
    });
    if (!hi) { out.textContent = ''; return; }
    var now = new Date();
    var f = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    out.innerHTML = '<span aria-hidden="true">◷</span> Livraison estimée entre le <strong>' + f.format(addBusiness(now, lo)) + '</strong> et le <strong>' + f.format(addBusiness(now, hi)) + '</strong> (' + lo + ' à ' + hi + ' jours ouvrés).';
  }

  /* ---------- Ouverture / fermeture ---------- */
  function focusables() { return Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; }); }
  function open(opts) {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.removeAttribute('inert');
    var sw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--vpcd-sw', sw + 'px');
    document.documentElement.classList.add('vpcd-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    setTimeout(function () {
      var target = (opts && opts.focus) || root.querySelector('.vpcd__cta') || root.querySelector('[data-vpcd-close]');
      if (target) target.focus({ preventScroll: true });
    }, 60);
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('inert', '');
    document.documentElement.classList.remove('vpcd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* Après un ajout (appelé par vitalia.js avec la réponse de /cart/add.js) */
  function afterAdd(resp) {
    if (resp && resp.sections && resp.sections[SECTION]) swap(resp.sections[SECTION]); else refresh();
    var item = resp && resp.items && resp.items[0];
    var msg = root.querySelector('[data-vpcd-added]');
    if (item && msg) {
      msg.innerHTML = '<span class="vpcd__tick" aria-hidden="true"></span> Ajouté : ' + String(item.product_title || item.title).replace(/[<>&]/g, '');
      msg.classList.add('is-on');
    }
    if (item) {
      var li = root.querySelector('.vpcd__item[data-variant-id="' + item.variant_id + '"]');
      if (li) li.classList.add('is-new');
    }
    open();
  }

  /* ---------- Interactions ---------- */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-vpcd-close]')) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-vpcd-qty]');
    if (q && !busy) {
      var li = q.closest('.vpcd__item');
      if (!li) return;
      busy = true; li.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: li.getAttribute('data-line-key'), quantity: parseInt(q.getAttribute('data-vpcd-qty'), 10) || 0, sections: SECTION, sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.sections) swap(j.sections[SECTION]); else return refresh(); })
        .catch(function () { return refresh(); })
        .then(function () { busy = false; var c = root.querySelector('[data-vpcd-close]'); if (c && !panel.contains(document.activeElement)) c.focus({ preventScroll: true }); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  /* Icône panier de l'en-tête : ouvre le tiroir (la page /cart reste accessible sans JavaScript et via « Voir le panier détaillé »). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.vp-header__icon[href$="/cart"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || /\/cart$/.test(window.location.pathname)) return;
    e.preventDefault(); refresh(); open();
  });
  /* Retour arrière depuis le paiement : le panier peut avoir changé. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  sync();
  window.VPCart = { open: open, close: close, refresh: refresh, afterAdd: afterAdd, section: SECTION };
}());
